import en from '@/internationalization/trans/chefs/en/en.json';
export default {
  trans: en,
};
